var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3439 6.47029C8.39449 6.47029 6.81419 8.0506 6.81419 10C6.81419 11.9494 8.39449 13.5297 10.3439 13.5297C12.2933 13.5297 13.8736 11.9494 13.8736 10C13.8736 8.0506 12.2933 6.47029 10.3439 6.47029Z",
    fill: "#D93D2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66328 0.313909C8.40816 -0.104636 12.2797 -0.104636 16.0245 0.313909C18.0863 0.544343 19.7493 2.16885 19.9913 4.23786C20.439 8.06624 20.439 11.9338 19.9913 15.7621C19.7493 17.8311 18.0863 19.4557 16.0245 19.6861C12.2797 20.1046 8.40816 20.1046 4.66328 19.6861C2.6015 19.4557 0.93853 17.8311 0.69654 15.7621C0.248777 11.9338 0.248777 8.06624 0.69654 4.23786C0.93853 2.16885 2.6015 0.544343 4.66328 0.313909ZM15.7742 3.48362C15.1744 3.48362 14.6882 3.96987 14.6882 4.56968C14.6882 5.1695 15.1744 5.65575 15.7742 5.65575C16.374 5.65575 16.8603 5.1695 16.8603 4.56968C16.8603 3.96987 16.374 3.48362 15.7742 3.48362ZM5.1851 10C5.1851 7.15087 7.49477 4.8412 10.3439 4.8412C13.193 4.8412 15.5027 7.15087 15.5027 10C15.5027 12.8491 13.193 15.1588 10.3439 15.1588C7.49477 15.1588 5.1851 12.8491 5.1851 10Z",
    fill: "#D93D2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.511746f1c927bdaae035c45cdcd513ec.svg";
export { ForwardRef as ReactComponent };